import {
	gettersInvestment
} from './items/Investment';
import {
	gettersBRRR
} from './items/BRRR';

import {
	gettersRenovations
} from './items/Renovations';

import {
	gettersLoanTerms
} from './items/LoanTerms';

import {
	gettersPropertyTaxesDepreciations
} from './items/PropertyTaxesDepreciations';

import {
	gettersMonthlyrevenue
} from './items/Monthlyrevenue';

import {
	gettersOperatingExpenses
} from './items/OperatingExpenses';

import {
	gettersFinancingExpense
} from './items/FinancingExpense';

import {
	gettersPMI
} from './items/PMI';

import {
	stateYourFinancialSituation,
	gettersYourFinancialSituation,
	mutationsYourFinancialSituation
} from './items/YourFinancialSituation';

import {
	gettersPurchaseOrPass
} from './items/PurchaseOrPass';

import {
	gettersMonthlyCashflow
} from './items/MonthlyCashflow';

import {
	gettersONEstYearReturnOnInvestment
} from './items/ONEstYearReturnOnInvestment';

import {
	gettersTotalExpenses30years
} from './items/TotalExpenses30years';

import {
	gettersTotalChangeInNetWorth30years
} from './items/TotalChangeInNetWorth30years';

export default {
	namespaced: true,

	state: {
		counter:       0,
		countComplete: 0,
		fieldsCount:   0,
		result:        {
			downpayment:                       '',
			home_price:                        '',
			terms:                             '',
			closing_costs:                     '',
			home_inspection:                   '',
			repairs:                           '',
			updates:                           '',
			building_value:                    '',
			land_value:                        '',
			assessment_percentage:             '',
			property_tax_rate:                 '',
			home_depreciation:                 '',
			unit_1_rent:                       '',
			unit_2_rent:                       '',
			unit_3_rent:                       '',
			unit_4_rent:                       '',
			other_revenue:                     '',
			property_management:               '',
			cap_ex_reserve:                    '',
			vacancy_reserve:                   '',
			repairs_reserve:                   '',
			water:                             '',
			electric:                          '',
			trash:                             '',
			other_expenses:                    '',
			interest_rate:                     '',
			annual_property_tax_override:      '',
			escrow_homeowners_insurance:       '',
			escrow_hazard_insurance:           '',
			pmi_expense:                       '',
			opex_tax_ins_monthly_rents_lt:     '',
			monthly_rents_price_gt:            '',
			cash_on_cash_return_gt:            '',
			gap_rate_gt:                       '',
			cash_reserves_coef:                '',
			beat_roi_of:                       '',
			after_repair_value:                '',
			construction_loan_closing_costs:   '',
			construction_loan_downpayment:     '',
			construction_loan_interest_rate:   '',
			month_until_refinance:             '',
		},
		subFields:     null,
		constants:     null,
		...stateYourFinancialSituation
	},

	getters: {
		result:        state => state.result,
		subFields:     state => state.subFields,
		constants:     state => state.constants,
		countComplete: state => state.countComplete,
		fieldsCount:   state => state.fieldsCount,
		...gettersBRRR,
		...gettersInvestment,
		...gettersRenovations,
		...gettersLoanTerms,
		...gettersPropertyTaxesDepreciations,
		...gettersMonthlyrevenue,
		...gettersOperatingExpenses,
		...gettersFinancingExpense,
		...gettersPMI,
		...gettersYourFinancialSituation,
		...gettersPurchaseOrPass,
		...gettersMonthlyCashflow,
		...gettersONEstYearReturnOnInvestment,
		...gettersTotalExpenses30years,
		...gettersTotalChangeInNetWorth30years
	},

	mutations: {
		setResult(state, payload) {
			state.result[payload.name] = payload.value;
		},
		setcountComplete(state, payload) {
			if (payload) {
				state.countComplete = payload;
			}
		},
		setFieldsCount(state, payload) {
			if (payload) {
				state.fieldsCount = payload;
			}
		},
		setSubFields(state, payload) {
			state.subFields = payload;
		},
		setConstants(state, payload) {
			state.constants = payload;
		},
		...mutationsYourFinancialSituation
	},

	actions: {
		/**
		 * action обновлення калькулятора розрахунків
		 * список actions повертає this._mutations
		 * ми використовуємо лише actions даного елементу "steps/calc/"
		 * при оновленні калькулятора потрібно обчислювати всі значення
		*/
		UPDATE_CALC({ commit, dispatch, state }) {
			Object.keys(this._mutations).forEach(v => {
				if (v.match('createUpdateDeal/steps/calc/')) {
					const mutation = v.replace('createUpdateDeal/steps/calc/', '');
					if (mutation !== 'setResult' && mutation !== 'setSubFields' && mutation !== 'setConstants') {
						commit(v.replace('createUpdateDeal/steps/calc/', ''));
					}
				}
			});
			let count = 0;
			Object.values(state.result).forEach((item) => {
				if (item !== null && item !== '') {
					count++;
				}
			});
			dispatch('CalculateAllFields');
			commit('setcountComplete', count);
		},
		CalculateAllFields({ commit, state }) {
			let count = 0;
			Object.values(state.result).forEach((item) => {
				count++;
			});
			commit('setFieldsCount', count);
		}
	}
};
